import axios from 'axios';
import { BASE_URL } from '../components/Constant';

//get admin setup
function getAdminSetup() {
  const endpoint = BASE_URL + 'adminSetup/getAdminSetup';
  return axios.get(endpoint, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

//create or update admin setup
function createAdminSetup(adminSetup) {
  const endpoint = BASE_URL + 'adminSetup/createAdminSetup';
  return axios.post(endpoint, adminSetup, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

function updateNewItemDefaultAccounts(accounts) {
  const endpoint = BASE_URL + 'adminSetup/newItemDefaultAccounts';
  return axios.put(endpoint, accounts, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

function updateNewItemDefaultTaxCode(taxCode) {
  const endpoint = BASE_URL + 'adminSetup/newItemDefaultTaxCode';
  return axios.put(endpoint, taxCode, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

const adminSetupService = {
  getAdminSetup,
  createAdminSetup,
  updateNewItemDefaultAccounts,
  updateNewItemDefaultTaxCode
};

export default adminSetupService;
